import { TechemTheme } from '@techem/techem-theme';
import checkmarkIcon from 'presentation/assets/icons/png/3x/checkmark_progress@3x.png';
import { ProgressBar } from 'baseui/progress-bar';
import { Spinner } from 'baseui/spinner';
import Icon from 'presentation/components/Icon';
import TitleWithPrevPageLink from 'presentation/components/TitleWithPrevPageLink';
import { WizardStepsContainer } from 'presentation/components/WizardSteps';
import { DISABLE_FLOW_DEEP_LINKING_PROTECTION } from 'config';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { setDiscountCodeNeedsValidation } from 'frameworks_drivers/redux/reducers/miscellaneous/miscSlice';
import { ProductService } from 'frameworks_drivers/redux/reducers/onboardingInformation';
import {
  setProducts,
  setReducedProducts,
  setSelectedProducts
} from 'frameworks_drivers/redux/reducers/onboardingInformation/onboardingInformationSlice';
import { paths } from 'frameworks_drivers/routes';
import store from 'store';
import { TrackerUtil } from 'tracking/TrackerUtil';
import { PriceClient } from '../../../../clients';
import { Products } from '../../../../entities/model/Product';

class LoadingOfferPage extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    var loadingItems: any[] = [];
    Array.from({ length: 4 }, (_, i) => i).forEach((index: number) => {
      loadingItems.push({
        isLoading: true,
        hasStartedLoading: false,
        currentValue: 0
      });
    });
    var onboardingInfo = store.getState().onboardingInfo;

    this.state = {
      onboardingInfo: onboardingInfo,
      loadingItems: loadingItems,
      renderNavigateToOfferpageElement: false
    };
  }

  increaseProgress(itemIndex: number, currentValue: number, callback = () => {}) {
    var newValue = currentValue + Math.random() * 50;
    this.setState({
      isLoading: true,
      loadingItems: [...this.state.loadingItems].map((item: any, index: number) => {
        if (index === itemIndex) {
          return {
            isLoading: item.isLoading,
            hasStartedLoading: item.hasStartedLoading,
            currentValue: newValue
          };
        } else return item;
      })
    });

    if (newValue < 100) {
      setTimeout(() => {
        this.increaseProgress(itemIndex, newValue, callback);
      }, Math.random() * 250);
    } else {
      callback();
    }
  }

  componentDidMount() {
    if (
      !DISABLE_FLOW_DEEP_LINKING_PROTECTION &&
      // Assumption: previous page has to be filled with user input before the user is allowed to visit this page
      store.getState().onboardingInfo.contactDetails.email === ''
    ) {
      return <Navigate to={paths.InputEMailAddress} replace={true} />;
    }
    this.setState({
      loadingItems: [...this.state.loadingItems].map((item: any, index: number) => {
        if (index === 0) {
          return {
            isLoading: true,
            hasStartedLoading: true,
            currentValue: 0
          };
        } else return item;
      })
    });

    const priceClient = new PriceClient();

    priceClient
      .getFullPrices()
      // By default, load base prices without any discount to be able to show those base prices and the according discounts if applicable.
      // If there is a discount code available, we re-load prices autoamtically once the offerpage has mounted.
      //APIPricing(store.getState().onboardingInfo, getABTestingObject())
      .then((response) => {
        const productList = response.products;

        // By default, add free of charge provider change service to the available services.
        const providerChangeService: ProductService = {
          name: Products.ProviderChangeService,
          price: 0,
          currency: this.props.t('currencyAsText'),
          appliedDiscount: 0
        };
        let availableProducts = [providerChangeService];
        availableProducts = availableProducts.concat(productList);

        store.dispatch(setProducts(availableProducts));
        store.dispatch(setReducedProducts([]));

        // By default, add at least heating costs to the booked services.
        // If there are already other saved services, don't overwrite anything to retain the existing state.
        if (store.getState().onboardingInfo.selectedProducts.length === 0) {
          const selectedProducts = availableProducts.filter(
            (item) =>
              item.name === Products.HeatingCosts || item.name === Products.HotWaterInvoicing
          );

          store.dispatch(setSelectedProducts(selectedProducts));
        } else {
          // Update each previously selected item with the latest data from the service, i.e. updated prices.
          store.dispatch(
            setSelectedProducts(
              store
                .getState()
                .onboardingInfo.selectedProducts.map((item) =>
                  store
                    .getState()
                    .onboardingInfo.products.find((product) => product.name === item.name)
                )
            )
          );
        }

        // Lastly, check if there is already a discount code available.
        // If yes, let's trigger an automatic API request for the discounted prices once the Offerpage mounts.
        if (store.getState().misc.referralDiscountCode) {
          store.dispatch(setDiscountCodeNeedsValidation(true));
        }

        this.setState({
          loadingItems: [...this.state.loadingItems].map((item: any, index: number) => {
            if (index === 0) {
              return {
                isLoading: false,
                hasStartedLoading: true,
                currentValue: 100
              };
            } else if (index === 1) {
              return {
                isLoading: true,
                hasStartedLoading: true,
                currentValue: 0
              };
            } else return item;
          })
        });

        this.increaseProgress(1, 0, () => {
          this.setState({
            loadingItems: [...this.state.loadingItems].map((item: any, index: number) => {
              if (index === 1) {
                return {
                  isLoading: false,
                  hasStartedLoading: true,
                  currentValue: 100
                };
              } else if (index === 2) {
                return {
                  isLoading: true,
                  hasStartedLoading: true,
                  currentValue: 0
                };
              } else return item;
            })
          });

          this.increaseProgress(2, 0, () => {
            this.setState({
              loadingItems: [...this.state.loadingItems].map((item: any, index: number) => {
                if (index === 2) {
                  return {
                    isLoading: false,
                    hasStartedLoading: true,
                    currentValue: 100
                  };
                } else if (index === 3) {
                  return {
                    isLoading: true,
                    hasStartedLoading: true,
                    currentValue: 0
                  };
                } else return item;
              })
            });

            this.increaseProgress(3, 0, () => {
              this.setState(
                {
                  onboardingInfo: store.getState().onboardingInfo,
                  loadingItems: [...this.state.loadingItems].map((item: any, index: number) => {
                    if (index === 3) {
                      return {
                        isLoading: false,
                        hasStartedLoading: true,
                        currentValue: 100
                      };
                    } else return item;
                  })
                },
                () => {
                  setTimeout(() => {
                    this.setState({
                      ...this.state,
                      renderNavigateToOfferpageElement: true
                    });
                  }, 500);
                }
              );
            });
          });
        });
      })
      .catch((error: any) => {
        console.error('Error: ', error);
        TrackerUtil.trackError('api-price-server-error', error);

        alert(error.message);
      });
  }

  render() {
    return (
      <Container className="pb-4 mb-5">
        <WizardStepsContainer />

        <div className="pb-5 pt-md-3">
          <TitleWithPrevPageLink title={this.props.t('pageOfferLoadingTitle')} />
        </div>

        {Array.from({ length: 4 }, (_, i) => i).map((itemId) => (
          <Row className="justify-content-center" key={'row-' + itemId}>
            <Col xs={11} md={8} lg={6}>
              <Row className="">
                <Col xs={7}>
                  <label id={`progress-label-${itemId}`} className="visually-hidden">
                    {this.props.t(`pageOfferLoadingItem${itemId}`)}
                  </label>
                  <p className="my-2 copy">{this.props.t(`pageOfferLoadingItem${itemId}`)}</p>
                </Col>

                <Col xs={5}>
                  <Row className="h-100">
                    <Col xs className="my-auto px-0">
                      <ProgressBar
                        value={this.state.loadingItems[itemId].currentValue}
                        successValue={100}
                        aria-labelledby={`progress-label-${itemId}`}
                        overrides={{
                          Bar: {
                            style: ({ $theme }) => ({
                              backgroundColor: TechemTheme.colors.backgroundSecondary
                            })
                          },
                          BarProgress: {
                            style: ({ $theme }) => ({
                              backgroundColor: '#007c94'
                            })
                          }
                        }}
                      />
                    </Col>

                    <Col xs="auto" className="my-auto px-1">
                      {this.state.loadingItems[itemId].isLoading ? (
                        <Spinner
                          $style={{
                            borderTopColor: '#007c94',
                            height: '22px',
                            width: '22px',
                            borderWidth: '2px',
                            animationDuration: '500ms'
                          }}
                        />
                      ) : (
                        <Icon iconSrc={checkmarkIcon} alt="checkmark icon" />
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        ))}

        {this.state.renderNavigateToOfferpageElement && <Navigate to={paths.Offer} />}
      </Container>
    );
  }
}

export default withTranslation()(LoadingOfferPage);
